const getPath = require('./get-path')
const m = require('moment')
const { LITERAL_TYPES } = require('./literal-types')

const literalDate = (lit) => {
  const parts = lit.split(':')
  const text = parts[0]
  let arg = parts.length > 1 && parts[1]
  if(!arg) arg = 1

  switch(text) {
  case 'TODAY':
    return [m(), 'day']
  case 'YESTERDAY':
    return [m().add(-1, 'day'), 'day']
  case 'TOMORROW':
    return [m().add(1, 'day'), 'day']
  }
  const parts2 = text.split('_')
  const dir = parts2.shift()
  const period = parts2.pop()
  let num = 0
  if(dir === 'LAST') num = -1
  if(dir === 'NEXT') num = 1
  if(parts.length > 1) {
    if(dir === 'NEXT') return [m(), m().add(num * arg, period), period]
    if(dir === 'LAST') return [m().add(num * arg, period), m(), period]
  }
  return [m().add(num * arg, period), period]
}

const compareDates = (date1, op, date2, type) => {
  if(!date2) {
    if(op === '=') {
      return date1 == null
    } else if(op === '!=') {
      return date1 != null
    }
    return false
  }
  if(!date1) return false
  
  const tmpDate2 = m(date2)
  if(typeof date2 === 'string' && LITERAL_TYPES.some(t => date2.startsWith(t))) date2 = literalDate(date2)
  else if (tmpDate2.isValid()) date2 = [tmpDate2, type === 'date' ? 'day' : 'second']
  else return false
  
  const d = m(date1)

  if(date2.length > 2) {
    switch(op) {
    case '=':
      return d.isBetween.apply(d, date2.concat(['[]']))
    case '!=':
      return !d.isBetween.apply(d, date2.concat(['[]']))
    case '>':
      date2.shift()
      return d.isAfter.apply(d, date2)
    case '<':
      date2.splice(1,1)
      return d.isBefore.apply(d, date2)
    case '>=':
      date2.shift()
      return d.isSameOrAfter.apply(d, date2)
    case '<=':
      date2.splice(1,1)
      return d.isSameOrBefore.apply(d, date2)
    }
  }
  
  switch(op) {
    case '=':
    return d.isSame.apply(d, date2)
    case '!=':
    return !d.isSame.apply(d, date2)
    case '>':
      return d.isAfter.apply(d, date2)
    case '<':
      return d.isBefore.apply(d, date2)
    case '>=':
      return d.isSameOrAfter.apply(d, date2)
    case '<=':
      return d.isSameOrBefore.apply(d, date2)
    case 'IN':
    // dafuq do we do here?
  }

}

const like = function(text, expression) {
  if (typeof expression !== 'string' || text === null) return false
  
  expression = expression
    .replace(new RegExp("([\\.\\\\\\+\\*\\?\\[\\^\\]\\$\\(\\)\\{\\}\\=\\!\\<\\>\\|\\:\\-])", "g"), "\\$1")
    .replace(/%/g, '.*').replace(/_/g, '.')
  return RegExp('^' + expression + '$', 'gi').test(text)
}

const walkTree = (item, node, fields) => {
  if(!node) return true
  switch(node.operation) {
    case 'AND':
      return walkTree(item, node.left, fields) && walkTree(item, node.right, fields)
    case 'OR':
      return walkTree(item, node.left, fields) || walkTree(item, node.right, fields)
    default:
      break
  }

  let fieldPath = node.left.values || [node.left.value]
  //aggregate field path
  if (!fieldPath || !fieldPath[0]) {
    let aggregateFieldPath = node.left.name
    if (node.left.arguments && node.left.arguments.value && node.left.arguments.value.length) {
      aggregateFieldPath += `(${node.left.arguments.value.map(v => v.value).join(',')})`
    }
    fieldPath = [aggregateFieldPath]
  }
  if (!fieldPath || !fieldPath[0]) return

  const itemVal = getPath(item, fieldPath)
  let field = fields[fieldPath.join('.')]
  
  //aggregate field type
  if (!field) {
    //match by alias or by <FUNCTION(PARAMETER)>
    field = Object.keys(fields).find(f => fields[f].aggregateAlias === fieldPath[0] 
      || `${fields[f].aggregateFunctionName}(${fields[f].fieldPath})` === fieldPath[0].replace(' ', ''))
    if (!field) return;
    field = fields[field]
  }
  
  const type = field && field.type && field.type.toLowerCase()

  if(type === 'date' || type === 'datetime') {
    return compareDates(itemVal, node.operation, node.right.value)
  }

  switch(node.operation) {
    case '=':
      return itemVal == node.right.value
    case '!=':
      return itemVal != node.right.value
    case '>':
      return itemVal > node.right.value
    case '<':
      return itemVal < node.right.value
    case '>=':
      return itemVal >= node.right.value
    case '<=':
      return itemVal <= node.right.value
    case 'LIKE':
      return like(itemVal, node.right.value)
    case 'IN':
      return node.right.value && node.right.value.map(val => val.value).indexOf(itemVal) !== -1
    default:
      break
  }
}

const where = (data, conditions, fields) => {
  let fieldMap = fields.reduce((obj, f) => {
    obj[f.fieldPath] = f
    return obj
  }, {})
  return data && data.slice().filter(item => walkTree(item, conditions, fieldMap))
}

module.exports = {
  where,
  walkTree
}
